import { IProgram } from "../interfaces/models/IEvent";
import { getDayKeyInTimezone } from "./dates";

export const compareProgramsBySchedule = (a: IProgram, b: IProgram): number => {
  if (a.startTime !== b.startTime) {
    return a.startTime - b.startTime;
  }
  return a.endTime - b.endTime;
};

export const sortProgramsBySchedule = (programs: IProgram[]): IProgram[] =>
  [...programs].sort(compareProgramsBySchedule);

/**
 * Groups programs by calendar day of startTime in the given timezone.
 * Day sections are chronological; sessions within a day are sorted by startTime.
 */
export const groupProgramsByDay = (
  programs: IProgram[],
  timeZone: string,
): Record<string, IProgram[]> => {
  const grouped: Record<string, IProgram[]> = {};

  programs.forEach((program) => {
    const dateKey = getDayKeyInTimezone(program.startTime, timeZone);

    if (!grouped[dateKey]) {
      grouped[dateKey] = [program];
    } else {
      grouped[dateKey].push(program);
    }
  });

  Object.keys(grouped).forEach((dateKey) => {
    grouped[dateKey].sort(compareProgramsBySchedule);
  });

  const sortedDayKeys = Object.keys(grouped).sort((a, b) =>
    a.localeCompare(b),
  );
  const sortedGrouped: Record<string, IProgram[]> = {};
  for (const dayKey of sortedDayKeys) {
    sortedGrouped[dayKey] = grouped[dayKey];
  }

  return sortedGrouped;
};
